import http, {RequestOptions, noContent, unwrap} from "@/api/http";
import {MeDto} from "@/api/types";

/** `GET /api/me` (#1): the logged-in user with their partner. 401 when not logged in. */
export const getMe = (options?: RequestOptions): Promise<MeDto> =>
    http.get<MeDto>("/me", options).then(unwrap);

/**
 * `POST /api/public/login`: exchanges the Google credential for the `ehestuToken` cookie. This endpoint predates the
 * migration and is not one of the numbered rows; it goes through the shared instance so that failures reach the
 * snackbar. After it resolves, dispatch `loadUser` to fetch the user.
 */
export const login = (code: string, options?: RequestOptions): Promise<void> =>
    http.post("/public/login", {code}, options).then(noContent);

/** `POST /api/public/logout`: clears the cookie. After it resolves, commit `resetUser`. */
export const logout = (options?: RequestOptions): Promise<void> =>
    http.post("/public/logout", undefined, options).then(noContent);
